//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'NoticeDetail',
  components: {
    ueditorFrom: function ueditorFrom() {
      return import('@/components/form-common/oa-wangeditor');
    }
  },
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    handleEmit: function handleEmit() {
      this.$emit('handleNoticeDetail');
    }
  }
};